import { useEffect } from 'react';
 
interface AmazonConnectChatProps {
   language:string,
   brand:string
}
 
 
const Current_page_url = window.location.href;
 
function extractBrandName(domain: string): string {
  return domain?.split('.')?.[0] || '';
}
const AmazonConnectChat: React.FC<AmazonConnectChatProps> = ({language,brand}) => {
 
   const sitename = extractBrandName(brand);
 
    const {PRODUCT_TYPE, SNIPPETId,WIDGET_ID,LAMBDA_URL } = (process.env.CHAT_CONFIG ? process.env.CHAT_CONFIG : {}) as {PRODUCT_TYPE?: string; SNIPPETId?: string; WIDGET_ID?:string; LAMBDA_URL?:string };
     
    useEffect(() => {
    const widgetId = WIDGET_ID;
    const globalFn = 'amazon_connect';
 
    // Prevent re-initialization
    // if ((window as any)[globalFn]) return;
 
    // Inject widget script and global handler
    (function (w, d, x, id) {
      const s = d.createElement('script');
      s.src = 'https://travelbrands-stage.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js';
      s.async = true;
      s.id = id;
      d.getElementsByTagName('head')[0].appendChild(s);
 
      (w as any)[x] = function () {
        ((w as any)[x].ac = (w as any)[x].ac || []).push(arguments);
      };
    })(window, document, globalFn, widgetId);
 
    const interval = setInterval(() => {
      const amazon_connect = (window as any).amazon_connect;
 
      if (typeof amazon_connect === 'function') {
        clearInterval(interval);
 
        amazon_connect('styles', {
          iconType: 'CHAT',
          openChat: { color: '#ffffff', backgroundColor: '#115da6' },
          closeChat: { color: '#ffffff', backgroundColor: '#115da6' },
        });
 
        amazon_connect('snippetId', SNIPPETId);
 
        amazon_connect('supportedMessagingContentTypes', [
          'text/plain',
          'text/markdown',
          'application/vnd.amazonaws.connect.message.interactive',
          'application/vnd.amazonaws.connect.message.interactive.response',
        ]);
 
        const attributes = `?agt_language=${language}&agt_name=Guest&agt_brand=${sitename}&Current_page_url=${encodeURIComponent(Current_page_url)}&Product_type=${PRODUCT_TYPE}`;
 
        amazon_connect('authenticate', (callback: (token: string) => void) => {
          fetch(`${LAMBDA_URL}${attributes}`)
            .then((res) => res.json())
            .then((data) => callback(data.token))
            .catch((err) => {
              console.error('Authentication error:', err);
            });
        });
      }
    }, 200);
 
    return () => {
      clearInterval(interval);
    };
  }, [language]);
 
  return null;
};
 
export default AmazonConnectChat;
 
 